export default __webpack_public_path__ + "static/media/main_img_2.99e49dc7.jpg";